import React from 'react'

// Icons & Images
import Logo from 'assets/icons/logo.svg';
import PageLine from 'assets/images/page-line.svg';


function Header(props) {
  return (
    <header>
        <div className='logo-container'>
            <img src={Logo} alt=''/>
        </div>
        <div className='page-name'>
            {/* <h1>Impact Tracking Board</h1> */}
            {/* <h1>Benefits Tracking Board</h1> */}
            <h1>{ props.meta.pagetitle }</h1>
            <img src={PageLine} alt='#'/>
        </div>
    </header>
  )
}

export default Header